module.exports = __webpack_public_path__ + "img/reason-bg.b8ab6176.png";